import { useState } from "react";
import { BlueEye } from "../../AllSvg";
import { Modal } from "react-bootstrap";
import { formatDate } from "../../Date";


function getAttendanceModalTitle(attendanceData, duration) {

    if (!Array.isArray(attendanceData) || attendanceData.length === 0) {
        return "No Attendance Details";
    }

    if (attendanceData.length === 1) {
        const date = attendanceData[0].date;
        return `Attendance Summary:  ${formatDate(date)} |  ${duration}`;
    } else {

        const sortedData = [...attendanceData].sort((a, b) => new Date(a.date) - new Date(b.date));
        const startDate = sortedData[0].date;
        const endDate = sortedData[sortedData.length - 1].date;
        return `Attendance Summary: ${formatDate(startDate)} - ${formatDate(endDate)} |  ${duration}`;
    }
}

// incomplete
const AttendanceDataTable = ({ attendanceData, duration }) => {

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => {
        setShow(true);
    };
    console.log(attendanceData, "attendance data ");


    return (
        <>
            <button className="text-button allproject-dashboard" onClick={handleShow}>
                <BlueEye />View
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modal-dialog request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title className="text-capitalize">{getAttendanceModalTitle(attendanceData, duration)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="flex-row">

                            {attendanceData && (
                                <>
                                    {duration === "multiple" ? (
                                        <table className="custom-att-table horizontal-table">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>In-Time</th>
                                                    <th>Out-Time</th>
                                                    <th>Work Duration</th>
                                                    <th>Day Status</th>
                                                    <th>Attendance Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {attendanceData?.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>{formatDate(row.date)}</td>
                                                        <td>{row.in_time}</td>
                                                        <td>{row.out_time}</td>
                                                        <td>{row.work_duration}</td>
                                                        <td className="attendance-status " data-status={row.day_status}>{row.day_status}</td>
                                                        <td className="attendance-status " data-status={row.attendence_status}>{row.attendence_status}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )
                                        :
                                        (

                                            <table className="custom-att-table vertical-table">
                                                <tbody>
                                                    <tr>
                                                        <th>Date</th>
                                                        <td>{formatDate(attendanceData[0].date)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>In-Time</th>
                                                        <td>{attendanceData[0].in_time}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Out-Time</th>
                                                        <td>{attendanceData[0].out_time}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Work Duration</th>
                                                        <td>{attendanceData[0].work_duration}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Day Status</th>
                                                        <td data-status={attendanceData[0].day_status} className="attendance-status">{attendanceData[0].day_status}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Attendance Status</th>
                                                        <td data-status={attendanceData[0].attendence_status} className="attendance-status" >{attendanceData[0].attendence_status}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )
                                    }

                                </>
                            )}

                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default AttendanceDataTable;

